<template>
    <div id="imageSlider">
        <div class="row first-row">
            <div class="col-lg-12" @click="clickForSlide" style="height: 100%">
                <agile ref="carousel" :options="options" :infinite="false"
                       style="border: 0px solid #6622ED; -webkit-border-radius: 5px;-moz-border-radius: 5px;border-radius: 5px; height: 100%">
                    <div v-for="items in sliderData">
                        <div class="slide slide--1">
                            <div class="slider-header row">
                                <div class="slider-header-content col-xs-12">
                                    <div class="slider-name col-xs-4">
                                        <h2 v-html="items.name"></h2>
                                    </div>
                                    <div class="slider-desc col-xs-8">
                                        <p v-html="items.description"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="slider-content">
                                <div class="slider-content-all" v-html="items.content">
                                </div>
                            </div>
                        </div>
                    </div>
                </agile>
            </div>
        </div>
        <button v-if="skip" class="skip-button" @click="skipAction">SKIP</button>
        <button v-if="!skip" class="end-button" @click="endAction">END</button>
    </div>
</template>

<script>
    import Constants from '@/utils/constants'
    import {Agile} from 'vue-agile'

    export default {
        name: "image-slider",
        components: {
            Agile: Agile
        },
        props: {
            getEula: {
                type: Function,
                required: false
            },
            sliderData: {
                type: Array,
                required: false
            },
            sliderLength: {
                type: Number,
                required: true
            }
        },
        mixins: [Agile],
        data() {
            return {
                skip: true,
                eulaData: null,
                options: {

                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                dots: false
                            }
                        },
                        {
                            breakpoint: 900,
                            settings: {
                                arrows: true,
                                dots: true,
                                infinite: false
                            }
                        }
                    ]
                }
            }
        },
        methods: {
            showModal() {
                //Show Slider
                $('#imageSlider').css('display', 'block');
            },
            hideModal() {
                //Hide Slider
                $('#login-page-container-for-blur').css('opacity', '1');
                $('#login-page-container-for-blur').css('pointer-events', 'auto');
                $('#login-page-container-for-blur').css('overflow-y', 'scroll');
                $('#imageSlider').css('display', 'none');
                this.$emit("getEula");
            },
            skipAction() {
                // Next Slide
                // Check currentSlide no for skip button
                let slideCount = this.$refs.carousel.currentSlide;
                let slideButtonCount = this.sliderLength - 2;
                if (slideCount === slideButtonCount) {
                    this.skip = false;
                }
                this.$refs.carousel.nextSlide();
            },
            endAction() {
                //Close Slide
                this.hideModal();
            },
            clickForSlide() {
                //Check each click event on div for skip/end buttons to show
                let slideCount = this.$refs.carousel.currentSlide;
                let slideButtonCount = this.sliderLength - 1;
                if (slideCount === slideButtonCount) {
                    this.skip = false;
                } else {
                    this.skip = true;
                }
            }
        },
        mounted() {
        },
        beforeMount() {
        },
        computed: {},
        watch: {}
    }
</script>

<style>
    #imageSlider {
        position: fixed;
        top: 8%;
        left: 10%;
        width: 80%;
        height: 80%;
        z-index: 99999;
        font-family: Digital-Serial-Bold;
    }

    #imageSlider .first-row {
        height: 100%;
    }

    .slider-header {
        width: 100%;
        height: auto;
        border-bottom: 1px solid black;
    }

    .slider-header-content {
        padding-left: 20px;
    }

    .slider-name {
        color: #2CCC57;
        padding-left: 10px;
        float: left;
    }

    .slider-desc {
        float: left;
        color: black;
        /*padding-left: 35px;*/
        font-size: 17px;
        padding-top: 30px;
    }

    .slider-desc p {
        overflow: hidden;
        white-space: nowrap;
        padding-left: 10px;
    }

    .slider-content {
        overflow: hidden;
        padding: 0 5% 0 5%;
    }

    .slider-content-all {
        margin-top: 25px;
        display: flex;
        justify-content: center;
    }

    .skip-button {
        position: relative;
        left: 80%;
        margin-top: 10px;
        width: 155px;
        height: 40px;
        background-color: #00fea9;
        border: none;
        color: black;
        font-family: Digital-Serial-Bold;
        font-size: 18px;
    }

    .skip-button:hover {
        background-color: #006150;
        color: white;
    }

    .end-button {
        position: relative;
        left: 80%;
        margin-top: 10px;
        width: 155px;
        height: 40px;
        background-color: #D40040;
        border: none;
        color: black;
        font-family: Digital-Serial-Bold;
        font-size: 18px;
    }

    .end-button:hover {
        background-color: #D42A56;
        color: white;
    }

    .slide {
        color: black;
        height: 100%;
        position: relative;
        background-color: #f1c40f;
        border: 2px solid black;
        overflow-y: scroll;
    }

    .slide--1 {
        background-color: white;
    }

    .slide h3 {
        font-size: 35px;
        font-weight: 300;
        left: 50%;
        margin: 0;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .agile__dots {
        bottom: 10px;
        left: 50%;
        position: absolute;
        transform: translateX(-50%);
    }

    .agile__dot button {
        height: 15px;
        width: 15px;
        -webkit-border-radius: 50px;
        -moz-border-radius: 50px;
        border-radius: 50px;
        background-color: transparent;
        border: 1px solid #00FFAB;
        margin-right: 5px;
    }

    .agile__dot button:hover {
        background-color: #D40040;
    }

    .agile__dot--current button {
        background-color: #6622ED;
    }

    .agile__arrow {
        height: 100%;
        top: 0;
        width: 50px;
        background: none;
        border: none;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        position: absolute;
    }

    .agile__arrow:hover {
        /*background-color: #6622ED;*/
        opacity: 0.5;
        border: none;
    }

    .agile__arrow--next {
        left: 93%;
    }

    .agile__arrow[disabled] {
        display: none;
    }

    .agile__arrow:hover #arrow-svg {
        fill: #fff;
    }

    .agile__arrow #arrow-svg {
        fill: rgba(255, 255, 255, .4);
        height: 25px;
    }

    .agile__list {
        height: 100%;
    }

    .agile__track{
        height: 100%;
    }

    .agile__slide{
        height: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/components/modals/ImageSlider.vue